/**
 * Aligned with Akashic-revamped-ui `CommonConstants.delimitersList` (file source + explorer).
 * `value` is what we send in `file_delimiter` (and presigned `databases[0]`), except
 * `Custom` — the user enters the character in a separate text field.
 */
export const FILE_DELIMITER_CHOICES = [
  { label: 'Comma (,)', value: ',' },
  { label: 'Tab (\\t)', value: '\t' },
  { label: 'Semicolon (;)', value: ';' },
  { label: 'Pipe (|)', value: '|' },
  { label: 'Colon (:)', value: ':' },
  { label: 'Space ( )', value: ' ' },
  { label: 'Custom delimiter', value: 'Custom' },
] as const

export const CUSTOM_FILE_DELIMITER = 'Custom' as const

export function isDelimitedTextFileName(fileName: string): boolean {
  return /\.(csv|txt|tsv)$/i.test((fileName ?? '').trim())
}

/**
 * For `.csv` / `.txt` / `.tsv`, delimiter is required (revamped: `config-generic` + presigned `databases[0].file_delimiter`).
 * `form.file_delimiter` is the selected option; when `Custom`, `customInput` is the real delimiter sent to the API.
 */
export function resolveFileDelimiterForApi(
  fileName: string,
  form: Record<string, string>,
  customInput: string
):
  | { ok: true; apiValue: string; includeInDatabases: boolean }
  | { ok: false; message: string } {
  if (!isDelimitedTextFileName(fileName)) {
    return { ok: true, apiValue: '', includeInDatabases: false }
  }
  const raw = (form.file_delimiter ?? '').trim()
  if (!raw) {
    return { ok: false, message: 'Select a file delimiter.' }
  }
  if (raw === CUSTOM_FILE_DELIMITER) {
    const c = customInput.trim()
    if (!c) {
      return { ok: false, message: 'Enter a custom delimiter (e.g. $ or %).' }
    }
    return { ok: true, apiValue: c, includeInDatabases: true }
  }
  return { ok: true, apiValue: raw, includeInDatabases: true }
}
